import { render, staticRenderFns } from "./ItemAggregator.template.vue?vue&type=template&id=02bec880&scoped=true&"
var script = {}
import style0 from "./ItemAggregator.template.vue?vue&type=style&index=0&id=02bec880&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bec880",
  null
  
)

export default component.exports